import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "services/http/AuthService";
const auth = new AuthService();

export default function withAuth(ComponentToProtect) {
  return class extends Component {
    constructor() {
      super();
      this._isMounted = false;
      this.state = {
        loading: true,
        redirect: false,
      };
    }

    componentDidMount() {
      this._isMounted = true;
      auth.loggedIn().then((response) => {
        if (!this._isMounted) {
          return;
        }
        if (response && response == true) {
          this.setState({ loading: false, redirect: false });
        } else {
          this.setState({ loading: false, redirect: true });
        }
      });
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    render() {
      const { loading, redirect } = this.state;
      if (loading) {
        return null;
      }

      if (redirect) {
        return <Navigate to="/login" replace />;
      } else {
        return (
          <React.Fragment>
            <ComponentToProtect {...this.props} />
          </React.Fragment>
        );
      }
    }
  };
}
